import type { BreadcrumbLinkProps } from '@/components/Breadcrumbs/types';
import type { Taxonomy } from '@/types/Taxonomy';
import { getBreadcrumbLinkLabel } from './get-breadcrumb-link-label';

export const getBreadcrumbLink = ({
  data,
}: {
  data: Taxonomy;
}): BreadcrumbLinkProps => {
  const label = getBreadcrumbLinkLabel({ data });
  const url = data.url;
  const id = data?.id?.toString() ?? `${label}-${url}`;

  return {
    id,
    label,
    slug: url,
    relative_url: url,
  };
};
